import { ReferralsPortalApplicationPayloadI } from '@recruitee/http/types';

export class SubmitApplication {
  public static type: string = '[HTTP] SubmitApplication';
  constructor(public payload: ReferralsPortalApplicationPayloadI) {}
}

export class LoadApplications {
  public static type: string = '[HTTP] LoadApplications';
}
